module.exports = __webpack_public_path__ + "img/rekord-logo.d1dd1b40.jpg";